/*
 * Yurls Shop — aantallen in de winkelwagen.
 *
 * ==========================================================================
 * WAAROM DIT BESTAAN MOET
 * ==========================================================================
 *
 * De bundelkorting van Shopify is een koop-X-krijg-Y-korting, en die knipt één
 * product op in meerdere regels: de weggestreepte exemplaren komen apart te
 * staan. Vijf keer hetzelfde boekje werd zo 2 + 1 + 2 in de winkelwagen.
 *
 * Erger nog: bij elke wijziging herverdeelt Shopify die regels opnieuw. Het
 * standaardscript van Dawn wijzigt een aantal op REGELNUMMER, en dat nummer
 * wijst na zo'n herverdeling naar een andere regel dan waarop je klikte. Dat
 * gaf sprongen in de aantallen en de melding "je kunt er maar X toevoegen" —
 * met het aantal van die andere regel erin.
 *
 * ==========================================================================
 * HOE HET WÉL WERKT
 * ==========================================================================
 *
 * Elke rij kent de sleutels van alle regels waarover Shopify dat ene boekje
 * verdeeld heeft. Wil je er negen, dan sturen we in één keer: eerste sleutel
 * negen, alle andere sleutels nul. Shopify voegt ze dan samen en knipt daarna
 * zelf opnieuw op zoals de korting het wil.
 *
 * Wat NIET werkt, en wat hier eerst stond: /cart/update met het variantnummer
 * als sleutel. Dat lijkt logisch — één variant, één totaal — maar zodra die
 * variant over meerdere regels verdeeld is, past Shopify het opgegeven aantal
 * op één van die regels toe en laat de rest staan. Vijf boekjes met een plus
 * erbij werden er zo negen.
 *
 * Na een geslaagde wijziging wordt de pagina herladen. Dat is met opzet: de
 * korting kan door jouw wijziging omslaan — een boekje erbij kan een ander
 * boekje gratis maken — en dan moeten de regels, het overzicht, de bundelbalk,
 * de teller in de header én de bijleg-carrousel allemaal opnieuw. Een halve
 * verversing die er één vergeet is hier gevaarlijker dan een herlaadbeurt.
 *
 * Verwachte opbouw:
 *   <yurls-cart-lines>
 *     <div data-variant="123" data-keys="123:abc,123:def">
 *       <button data-step="-1">  <input data-qty>  <button data-step="1">
 *       <button data-remove>
 *       <span data-error></span>
 *     </div>
 *   </yurls-cart-lines>
 */

if (!customElements.get('yurls-cart-lines')) {
  customElements.define(
    'yurls-cart-lines',
    class YurlsCartLines extends HTMLElement {
      connectedCallback() {
        this.busy = false;

        this.onClick = (event) => {
          var remove = event.target.closest('[data-remove]');
          if (remove) {
            event.preventDefault();
            this.apply(remove.closest('[data-variant]'), 0);
            return;
          }

          var step = event.target.closest('[data-step]');
          if (!step) return;

          var row = step.closest('[data-variant]');
          var input = row ? row.querySelector('[data-qty]') : null;
          if (!input) return;

          var next = (parseInt(input.value, 10) || 0) + (parseInt(step.dataset.step, 10) || 0);
          this.apply(row, next);
        };

        this.onChange = (event) => {
          var input = event.target.closest('[data-qty]');
          if (!input) return;
          this.apply(input.closest('[data-variant]'), parseInt(input.value, 10) || 0);
        };

        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
      }

      apply(row, quantity) {
        if (!row || this.busy) return;

        var keys = (row.dataset.keys || '').split(',').filter(Boolean);
        if (!keys.length) return;

        // Onder nul bestaat niet, en nul betekent verwijderen.
        if (quantity < 0) quantity = 0;

        // Alles op de eerste sleutel, de rest leeg. Zie de toelichting bovenaan.
        var updates = {};
        keys.forEach(function (key, index) {
          updates[key] = index === 0 ? quantity : 0;
        });

        var errorEl = row.querySelector('[data-error]');
        if (errorEl) errorEl.textContent = '';

        this.busy = true;
        row.setAttribute('data-busy', '');

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then((result) => {
            if (!result.ok) {
              throw new Error(result.data.description || result.data.message || '');
            }
            window.location.reload();
          })
          .catch((error) => {
            this.busy = false;
            row.removeAttribute('data-busy');

            // Bij een fout blijft het oude aantal staan; anders zou het veld
            // iets tonen wat niet in de winkelwagen zit.
            var input = row.querySelector('[data-qty]');
            if (input && input.dataset.current) input.value = input.dataset.current;

            if (errorEl) {
              errorEl.textContent =
                error.message || 'Dit lukte niet. Probeer het nog eens.';
            }
          });
      }
    }
  );
}